export interface StorageService {
  dataStorage(storage: string): any
  updateDataFromStorage(storage: string, id: string, value: any): void
  getDataFromStorage(storage: string, id: string): any
  removeDataFromStorage(storage: string, id: string): void
  addDataToStorage(storage: string, id: string, value: any): void
  clearDataStorage(storage: string): void
}

export const StorageService: StorageService = {
  dataStorage(storage: string) {
    return window[storage as keyof Window]
  },
  updateDataFromStorage(storage: string, id: string, value: any): void {
    this.removeDataFromStorage(storage, id)
    this.addDataToStorage(storage, id, value)
  },
  getDataFromStorage(storage: string, id: string): any {
    return JSON.parse(this.dataStorage(storage).getItem(id))
  },
  removeDataFromStorage(storage: string, id: string): void {
    this.dataStorage(storage).removeItem(id)
  },
  addDataToStorage(storage: string, id: string, value: any): void {
    this.dataStorage(storage).setItem(id, JSON.stringify(value))
  },
  clearDataStorage(storage: string): void {
    this.dataStorage(storage).clear()
  }
}
